import { Controller } from "stimulus"

export default class extends Controller {

  print() {
    window.print();
    return false;
  }
}
